import axios from "axios";
import * as Yup from "yup";
import { EMAIL_REGEX } from "@/func/emailValidation";

class EmailMarketingLeadsProvider {
  constructor() {
    this.baseUrl = "/wp-json/api/v1/email-marketing";
    this.sessionId = sessionStorage.getItem("sessionId") || null;

    this.validationSchema = Yup.object().shape({
      email: Yup.string().email().matches(EMAIL_REGEX).required(),
      first_name: Yup.string().min(1).required(),
      product_name: Yup.string().required(),
      product_qty: Yup.number().min(1).required(),
    });
  }

  validate(data) {
    try {
      this.validationSchema.validateSync(data, { abortEarly: false });
      return true;
    } catch {
      return false;
    }
  }

  async initialize() {
    if (this.sessionId) {
      return this.sessionId;
    }

    try {
      const { data } = await axios.get(`${this.baseUrl}/session`);
      this.sessionId = data.sessionId;
      sessionStorage.setItem("sessionId", this.sessionId);
      return this.sessionId;
    } catch (error) {
      throw new Error("Failed to process your request. Please check your information and try again.");
    }
  }

  async createLead(leadData) {
    if (!this.sessionId) {
      throw new Error("Failed to process your request. Please refresh the page and try again.");
    }

    try {
      const { data } = await axios.post(`${this.baseUrl}/createLead`, leadData, {
        headers: {
          "X-Session-Id": this.sessionId,
        },
      });
      return data;
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      throw new Error(message);
    }
  }
}

export default EmailMarketingLeadsProvider;
